import React, { PureComponent, Suspense } from 'react';
import { LayoutContentWrapper } from "@components/utility/layoutWrapper.style.js";
import { Col, Popover, Row, Spin } from "antd";
import basicStyle from "@assets/styles/constants.js";
import { WidgetWrapper } from "@components/WidgetBox/Widgets.styles.js";
import _ from "lodash";
import { connect, useSelector } from "react-redux";
import { NoDecimalFormat, PercentFormat } from "@components/Format";
import { api } from "@redux/api";
import workorder_actions from "@redux/workorder/actions";
import gas_actions from "@redux/gas/actions";
import electricity_actions from "@redux/electricity/actions";
import PeiChart from "@containers/facility/Overview/PieChart";
import { CaretDownOutlined, CaretUpOutlined, InfoCircleOutlined } from "@ant-design/icons";
import PermissionControl from "@components/Permission/Permission";
import moment from "moment";
import { withRouter } from "@/router/withRouter";
import appActions from "@redux/app/actions";
import { DashBoardGaugeCharts } from '@/containers/UtilityData/New-Summary/components/GaugeCharts';
import { DashboardCards, WorkorderChart, EquipmentChart } from './components';
import SpiderChart from '@/containers/PortfolioManage/Dashboard/components/SpiderChart';
import { generateRadarDataFromFacilities } from '@/services/company';
import { emitEvent, EventName, useEventBus } from '@/hooks/useEventBus';
import { useKeepAliveContext } from '@/hooks/use-keep-alive-context';
import { chartIdDashBordMappings } from '@/containers/PdfReport/template/dashboard/dashboard-chart';
import { buildFacilityPath, extractContextFromPath, getFacilityContext } from '@/utils/route-context';

const contentStyle = {
    width: '100%',
    height: '100%',
    background: '#fff',
    borderRadius: 8,
    border: '1px solid #f0f0f0',
    aspectRatio: '2 / 1',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.06)',
}

const colLayout = {
    xs: 24,
    lg: 12,
    xxl: 8,
    style: {
        padding: '4px',
        width: '100%',
        minHeight: 200
    }

}

const styles = {
    wisgetPageStyle: {
        display: 'flex',
        flexFlow: 'row wrap',
        alignItems: 'flex-start',
        overflow: 'hidden',
        width: '100%',
        justifyContent: 'center'
    },
};

const cardStyle = {
    height: '100%',
    background: '#fff',
    borderRadius: 8,
    border: '1px solid #f0f0f0',
    minHeight: 140,
    maxHeight: 170,
}

class Overview extends PureComponent {

    constructor(props) {
        super(props);
        this.child = React.createRef();
        this.performanceRequestId = 0;
        this.state = {
            gas_latest_consumption: 0,
            gas_last_consumption: 0,
            gas_latest_consumption_diff: 0,
            gas_latest_cost: 0,
            gas_last_cost: 0,
            gas_latest_cost_diff: 0,
            gas_latest_service_month: '',
            gas_last_service_month: '',
            elec_latest_consumption: 0,
            elec_last_consumption: 0,
            elec_latest_consumption_diff: 0,
            elec_latest_cost_diff: 0,
            elec_latest_cost: 0,
            elec_last_cost: 0,
            elec_latest_service_month: '',
            elec_last_service_month: '',

            workorder: [],
            elecgas: [],
            equipment_condition: [],
            equipment_category: [],
            project: [],

            electricity_treemap_data: [],
            gas_treemap_data: [],
            past7_past30: [],

            isLoading: false,

            groupedMonthlyData: [],
            groupedPriorityData: [],
            groupedStatusData: [],

            total_eui: 0,
            facilityPerformanceData: null,
            facilityPerformanceLoading: false,
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.facility_id !== this.props.facility_id) {
            this.handleInitRender()
        }
    }

    componentDidMount() {
        this.handleInitRender()
    }

    handleInitRender = (props = this.props) => {
        // console.log('this.props.permission', this.props.permission)
        const companyId = props.company_selected || props.facilityContext?.companyId;

        if (!companyId) {
            return null
        }
        this.setState({
            isLoading: true
        })

        let apiCalls = [];

        this.fetchFacilityPerformanceMetrics(props);

        if (props.permission?.workorder && props.permission?.workorder !== 0) {
            apiCalls.push(api.allworkorderview());
        }
        if (props.permission?.gas && props.permission?.gas !== 0) {
            apiCalls.push(api.getAllElecGasComparisionView());
        }
        if (props.permission?.equipment && props.permission?.equipment !== 0) {
            apiCalls.push(api.allequipmentview());
        }
        if (props.permission?.electricity && props.permission?.electricity !== 0) {

            apiCalls.push(api.get_electricity_summary(12));
            apiCalls.push(api.get_gas_summary(12));
        }

        if (props.permission?.gas && props.permission?.gas !== 0) {

            apiCalls.push(api.getElecGas());
            apiCalls.push(api.getFacilityConsumption(companyId));
        }


        Promise.all(apiCalls)
            .then(response => {
                let index = 0;

                const resData = {
                    workorder: props.permission?.workorder && props.permission?.workorder !== 0 ? _.get(response[index++], 'data') : undefined,
                    elecGasComparision: props.permission?.gas && props.permission?.gas !== 0 ? _.get(response[index++], 'data') : undefined,
                    equipment: props.permission?.equipment && props.permission?.equipment !== 0 ? _.get(response[index++], 'data') : undefined,
                    electricity_summary: props.permission?.electricity && props.permission?.electricity !== 0 ? _.get(response[index++], 'data') : undefined,
                    gas_summary: props.permission?.gas && props.permission?.gas !== 0 ? _.get(response[index++], 'data') : undefined,
                    elecgas: props.permission?.gas && props.permission?.gas !== 0 ? _.get(response[index++], 'data.results') : undefined,
                    electricity_treemap: props.permission?.gas && props.permission?.gas !== 0 ? _.get(response[index], 'data.electricity') : undefined,
                    gas_treemap: props.permission?.gas && props.permission?.gas !== 0 ? _.get(response[index], 'data.gas') : undefined,
                };

                this.Init(resData.workorder, resData.elecGasComparision, resData.equipment, resData.electricity_summary, resData.gas_summary,
                    resData.elecgas, resData.electricity_treemap, resData.gas_treemap);


                this.setState({
                    isLoading: false
                });
            })
            .catch(error => {
                this.setState({
                    isLoading: false
                });
            });

    }

    fetchFacilityPerformanceMetrics = (props = this.props) => {
        const facilityId = props.facility_id || props.facilityContext?.facilityId;

        if (!facilityId) {
            this.setState({
                facilityPerformanceData: null,
                facilityPerformanceLoading: false,
            });
            return;
        }

        this.setState({
            facilityPerformanceLoading: true,
        });

        const requestId = ++this.performanceRequestId;

        api.getFacilityPerformanceMetrics(facilityId)
            .then(response => {
                if (requestId !== this.performanceRequestId) {
                    return;
                }

                const responseData = _.get(response, 'data', {});
                const metricsData = _.get(responseData, 'data', {});

                this.setState({
                    facilityPerformanceData: {
                        id: facilityId,
                        name: props.facility_selected || metricsData.facility_name || 'Facility',
                        performance_metrics: responseData.performance_metrics || {},
                        performance_breakdown: responseData.performance_breakdown || [],
                        overall_score: metricsData.overall_score,
                        color: '#5470c6',
                    },
                    facilityPerformanceLoading: false,
                });
            })
            .catch(() => {
                if (requestId !== this.performanceRequestId) {
                    return;
                }

                this.setState({
                    facilityPerformanceData: null,
                    facilityPerformanceLoading: false,
                });
            });
    }


    Init = (workorder_data, elecGasComparision, equipment_data, electricity_summary, gas_summary, elecgas_data, electricity_treemap, gas_treemap) => {
        let gas_comparision = elecGasComparision?.gas;
        let elec_comparision = elecGasComparision?.electricity;

        let electricity_treemap_data = electricity_treemap;
        let gas_treemap_data = gas_treemap;
        let equipment_condition = equipment_data?.grouped_status_data;
        let equipment_category = equipment_data?.grouped_category_data;
        let elecgas = elecgas_data;
        let total_eui = 0;
        total_eui = gas_summary.annual_eui + electricity_summary.annual_eui;
        let groupedPriorityData = workorder_data?.grouped_priority_data;
        let groupedStatusData = workorder_data?.grouped_status_data;
        let groupedMonthlyData = workorder_data?.sorted_monthly_data;
        let past7_past30 = workorder_data?.past7_past30;

        this.setState({
            gas_latest_consumption: gas_comparision?.latest_consumption,
            gas_last_consumption: gas_comparision?.last_consumption,
            gas_latest_cost: gas_comparision?.latest_cost,
            gas_last_cost: gas_comparision?.last_cost,
            gas_latest_consumption_diff: gas_comparision?.consumption_diff,
            gas_latest_cost_diff: gas_comparision?.cost_diff,
            gas_latest_service_month: gas_comparision?.latest_service_month,
            gas_last_service_month: gas_comparision?.last_service_month,

            elec_latest_consumption: elec_comparision?.latest_consumption,
            elec_last_consumption: elec_comparision?.last_consumption,
            elec_latest_consumption_diff: elec_comparision?.consumption_diff,
            elec_latest_cost_diff: elec_comparision?.cost_diff,
            elec_latest_cost: elec_comparision?.latest_cost,
            elec_last_cost: elec_comparision?.last_cost,
            elec_latest_service_month: elec_comparision?.latest_service_month,
            elec_last_service_month: elec_comparision?.last_service_month,

            groupedPriorityData,
            groupedStatusData,
            groupedMonthlyData,
            past7_past30,
            elecgas,
            electricity_treemap_data,
            gas_treemap_data,
            total_eui,
            equipment_condition,
            equipment_category,
        })
    }


    handleRender = (data) => {
        return {
            total_cost: _.get(data[0], 'costs'),
            prev_cost: _.get(data[1], 'costs'),
            total_usage: _.get(data[0], 'usage'),
            prev_usage: _.get(data[1], 'usage'),
        }
    }

    onChange = (e) => {
        this.setState({
            period: Number(e.target.value)
        }, function () {
            this.Init()
        })
    }

    renderCard = (title, label, value, prev_value, ratio, unit, color, latest_service_month, last_service_month) => {
        return (
            <WidgetWrapper>

                <div className={" p-6 bg-white shadow rounded-md corner-flower-" + color}>
                    <div className="flex mb-10 items-center justify-between">

                        <h3 className={'small-title '}>{title}</h3>
                        <Popover content={
                            <div>
                                {'percent change comparing to same month of previous year'}
                            </div>
                        } trigger="hover"
                        >
                            <InfoCircleOutlined style={{ color: 'orange' }} />
                        </Popover>
                    </div>
                    <div className="flex items-center mb-5">
                        <span className="text-5xl font-bold">{NoDecimalFormat(value)}</span>
                        <span className="text-3xl ml-1">{unit}</span>

                        <span
                            className={ratio > 0 ? 'bg-red-500 inline-block ml-2 py-1 px-2  rounded-full text-white'
                                : 'bg-green-500 inline-block ml-2 py-1 px-2  rounded-full text-white'}>
                            {PercentFormat(ratio)}
                        </span>


                    </div>
                    <div className="relative w-full h-1 mb-5  rounded">
                        <div className="absolute top-0 left-0 w-4/6 h-full bg-purple-500 rounded"></div>
                    </div>
                    <p className=" ">{moment(latest_service_month).format('YYYY MMM')} {ratio > 0 ?
                        <CaretUpOutlined style={{ fontSize: '16px', color: 'red' }} /> :
                        <CaretDownOutlined style={{ fontSize: '16px', color: 'green' }} />}
                        {' ' + moment(last_service_month).format('YYYY MMM')}
                    </p>
                </div>

            </WidgetWrapper>
        )
    }

    renderTopStats = () => {
        return <DashboardCards />;
    }

    renderFacilityScoreSpiderChart = () => {
        const { facilityPerformanceData, facilityPerformanceLoading } = this.state;

        if (facilityPerformanceLoading) {
            return (
                <div style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Spin size="large" />
                </div>
            );
        }

        if (!facilityPerformanceData) {
            return (
                <div style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#999' }}>
                    No facility score data
                </div>
            );
        }

        const facilities = [facilityPerformanceData];
        const radarData = generateRadarDataFromFacilities(facilities);

        return (
            <SpiderChart
                radarData={radarData}
                facilities={facilities}
                title="Facility Score"
                showTitle
                useMobileDrawerTooltip={this.props.view === 'MobileView'}
                style={{ width: '100%', height: '100%', borderRadius: 8, overflow: 'hidden' }}
            />
        );
    }

    onPrint = () => {
        this.child.current.composeManagerPDF('Report', 0);
    }



    render() {
        const { rowStyle, colStyle } = basicStyle;
        let facility_data = [];
        for (let i = 0; i < this.props.facility.length; i++) {
            facility_data.push(
                this.props.facility[i].record
            )
        }

        return (
            <LayoutContentWrapper>
                <div id={'Report_0'} style={styles.wisgetPageStyle} className={'m-4'}>
                   {this.renderTopStats()}
                    <Row style={{ margin: '-4px', width: '100%' }}>
                            <Col {...colLayout} className={chartIdDashBordMappings.charts[0]}>
                                <div style={contentStyle} className='Dashboard_charts_0'>
                                    <WorkorderChart />
                                </div>
                            </Col>
                            <Col {...colLayout} className={chartIdDashBordMappings.charts[4]}>
                                <div style={contentStyle} className='Dashboard_charts_4'>
                                    <EquipmentChart />
                                </div>
                            </Col>
                            <Col {...colLayout} className={chartIdDashBordMappings.charts[2]}>
                                <div style={contentStyle} className='Dashboard_charts_2'>
                                    <DashBoardGaugeCharts title={'EUI Last 12 Month (kBtu/sqft-yr)'} />
                                </div>
                            </Col>
                            <Col {...colLayout} className={chartIdDashBordMappings.charts[3]}>
                                <div style={contentStyle} className='Dashboard_charts_3'>
                                    {this.renderFacilityScoreSpiderChart()}
                                </div>
                            </Col>
                    </Row>
                </div>
            </LayoutContentWrapper>
        );
    }
}


const mapStateToProps = state => {
    const facilitySelectedId = _.get(state.Facility, 'selected.Id');
    const subTaskSelectedId = _.get(state.SubTask, 'selected.Id');

    // console.log('props', state)
    return {
        electricity: _.get(state.Electricity, 'data'),
        gas: _.get(state.Gas, 'data'),
        water: _.get(state.Water, 'data'),
        workorder: _.get(state.WorkOrder, 'data'),
        facility_id: facilitySelectedId || subTaskSelectedId,
        facility: _.get(state.Facility, 'data'),
        facility_selected: _.get(state.Facility, 'selected.value'),
        company_selected: _.get(state.Facility, 'selected.record.company_id'),
        permission: _.get(state.Auth, 'permission'),
        view: _.get(state.App, 'view'),
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setElectricitySuccess: (e) => dispatch(electricity_actions.ElectricitySuccess(e)),
        setGasSuccess: (e) => dispatch(gas_actions.GasSuccess(e)),
        setWorkorderSuccess: (e) => dispatch(workorder_actions.WorkorderSuccess(e)),
        setCurrentRouter: (e) => dispatch(appActions.changeCurrent(e)),
    }
}

const withHooks = (Component) => {
    const NewComponent = (props) => {
  
      const { closeTab } = useKeepAliveContext()
      const stateFacilityContext = useSelector((state) => getFacilityContext(state));
      const routeFacilityContext = extractContextFromPath(props.location?.pathname);
      const facilityContext = {
        companyId: routeFacilityContext.companyId || stateFacilityContext.companyId,
        facilityId: routeFacilityContext.facilityId || stateFacilityContext.facilityId,
      };
      const equipmentListPath = buildFacilityPath('equipment', facilityContext) || '/switch-view';
  
      useEventBus(EventName.CLOSE_EQUIPMENT, () => {
        closeTab(equipmentListPath)
      })
  
      return (
        <Component
          {...props}
          facilityContext={facilityContext}
        />
      )
    }
    return NewComponent
  }

export default withHooks(withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(Overview)));
